import tw, { styled } from 'twin.macro';

const MarkdownImage = styled.img`
  ${tw`w-full py-4`}
`;

export default MarkdownImage;